import React from "react";
import styled from "styled-components";
import {
  FiAlertCircle,
  FiAlertTriangle,
  FiCheckCircle,
  FiInfo,
  FiX,
} from "react-icons/fi";
import { fontFamily } from "../styles/theme";

const VARIANT_STYLES = {
  success: {
    background: "#d1e7dd",
    border: "#badbcc",
    color: "#0f5132",
    Icon: FiCheckCircle,
  },
  danger: {
    background: "#f8d7da",
    border: "#f5c2c7",
    color: "#842029",
    Icon: FiAlertCircle,
  },
  warning: {
    background: "#fff3cd",
    border: "#ffecb5",
    color: "#664d03",
    Icon: FiAlertTriangle,
  },
  info: {
    background: "#cff4fc",
    border: "#b6effb",
    color: "#055160",
    Icon: FiInfo,
  },
};

export function FormAlert({
  variant = "info",
  title,
  message,
  onDismiss,
  actionLabel,
  onAction,
}) {
  if (!message && !title) return null;

  const styles = VARIANT_STYLES[variant] || VARIANT_STYLES.info;
  const Icon = styles.Icon;

  return (
    <AlertRoot
      role="alert"
      $background={styles.background}
      $border={styles.border}
      $color={styles.color}
    >
      <AlertIcon aria-hidden>
        <Icon size={18} />
      </AlertIcon>
      <AlertBody>
        {title && <AlertTitle>{title}</AlertTitle>}
        {message && <AlertMessage>{message}</AlertMessage>}
        {actionLabel && onAction && (
          <AlertAction type="button" onClick={onAction}>
            {actionLabel}
          </AlertAction>
        )}
      </AlertBody>
      {onDismiss && (
        <DismissButton type="button" onClick={onDismiss} aria-label="Dismiss">
          <FiX size={18} />
        </DismissButton>
      )}
    </AlertRoot>
  );
}

const AlertRoot = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  width: 100%;
  padding: 14px 16px;
  border: 1px solid ${({ $border }) => $border};
  border-radius: 8px;
  background: ${({ $background }) => $background};
  color: ${({ $color }) => $color};
  font-family: ${fontFamily.font};
  box-sizing: border-box;
`;

const AlertIcon = styled.span`
  flex-shrink: 0;
  margin-top: 2px;
  display: flex;
  align-items: center;
`;

const AlertBody = styled.div`
  flex: 1;
  min-width: 0;
`;

const AlertTitle = styled.strong`
  display: block;
  font-size: 14px;
  font-weight: 700;
  line-height: 1.4;
  margin-bottom: 4px;
`;

const AlertMessage = styled.p`
  margin: 0;
  font-size: 14px;
  line-height: 1.5;
`;

const AlertAction = styled.button`
  margin-top: 10px;
  padding: 0;
  border: 0;
  background: none;
  color: inherit;
  font-family: inherit;
  font-size: 14px;
  font-weight: 700;
  text-decoration: underline;
  cursor: pointer;

  &:hover {
    opacity: 0.85;
  }
`;

const DismissButton = styled.button`
  flex-shrink: 0;
  border: 0;
  background: transparent;
  color: inherit;
  opacity: 0.7;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;

  &:hover {
    opacity: 1;
  }
`;
